import styled, { css } from 'styled-components/macro';

import LinkWithTop from '../Links/LinkWithTop';
import { responsive } from '../../resources/constantes.json';

const SLink = styled(LinkWithTop)`
  width: 100%;
  height: 100%;
  display: block;
  color: #283f5f;
  font-size: 14px;
  padding: 2rem 1.2rem;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    font-weight: bold;
    color: #215ccc;
    background: rgb(0, 0, 0, 0.1);
  }

  .search-highlight {
    background: inherit;
    font-weight: bold;
    color: #215ccc;
  }
`;

const Item = styled.li`
  cursor: ${({ cursor }) => cursor || 'pointer'};
  display: block;
  height: auto;
  color: #283f5f;
  font-size: 14px;
  white-space: 'normal';
  word-wrap: 'normal';
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.3;
  &:first-child {
    border-radius: 5px 5px 0 0;
  }
  &:last-child {
    border-radius: 0 0 5px 5px;
  }
  ${({ isActive }) =>
    isActive &&
    css`
      color: rgba(0, 0, 0, 0.85);
      background: rgba(0, 0, 0, 0.1);
    `}
  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: bold;
    `}
`;

const Input = styled.input`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 50px;
  padding-left: 10px;
  border: none;
  font-size: 14px;
  background-color: transparent;
  color: #ffff;
  // transition: background-color 0.3s ease 0s;
  border-bottom: 1px solid #fff;
  ::placeholder {
    color: #fff;
    font-style: italic;
    opacity: 0.9;
  }
`;

const InputHome = styled.input`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-right: 50px;
  padding-left: 16px;
  font-size: 24px;
  background-color: transparent;
  color: #AAB0BA;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #D8DFEA;
  outline: none;

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding-right: 50px;
    padding-left: 10px;
    border: none;
    font-size: 14px;
    background-color: transparent;
    color: #ffff;
    // transition: background-color 0.3s ease 0s;
    border-bottom: 1px solid #fff;
    ::placeholder {
      color: #fff;
      font-style: italic;
      opacity: 0.9;
    }
  }
`;

const MenuWrapper = styled.div`
  padding: 20px;
  position: absolute;
  display: flex;
  width: 100%;
  height: 428px;
  background: white;
  border-radius: 20px;
  translate: ${({ openTop }) => (!openTop ? `0 4px` : '0 calc(-100% - 40px);')};
  display: ${({ isOpen }) => !isOpen && `none`};
  box-sizing: border-box;

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    height: unset;
  }

`;
const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;

  li:nth-child(odd) {
    background: white;
  }
  li:nth-child(even) {
    background: #f5f8fd;
  }

  /*IE11 fix IE11: Child containers overflow when max-height on parent is reached https://github.com/philipwalton/flexbugs/issues/216 */
  max-height: 320px;
`;

const SearchIconWrapper = styled.div`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 10px;
  top: 0;
  width: 47px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;

  /*IE11: Column flex items set to align-items: center overflow their container https://github.com/philipwalton/flexbugs#flexbug-2 */
  max-width: 47px;
`;
const SearchIconWrapperHome = styled.div`
  background-color: transparent;
  border: none;
  position: absolute;
  right: 10px;
  top: 0;
  width: 30px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  align-items: center;

  /*IE11: Column flex items set to align-items: center overflow their container https://github.com/philipwalton/flexbugs#flexbug-2 */
  max-width: 30px;
`;

const Root = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  z-index: 1000;
`;

export {
  SLink,
  Menu,
  MenuWrapper,
  Input,
  Item,
  SearchIconWrapper,
  SearchIconWrapperHome,
  Root,
  InputHome,
};
